import React from 'react';
import MUIDataTable from "mui-datatables";
import { Badge } from 'reactstrap';
import { createMuiTheme } from '@material-ui/core/styles';

class AllCoachTable extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            rowsExpanded: [],
            denseTable: false,
            vertical: true
        };
    }

    getMuiTheme = () =>
        createMuiTheme({
            overrides: {
                MUIDataTable: {
                    root: {
                        backgroundColor: '#AAF',
                    },
                    paper: {
                        boxShadow: 'none',
                    },
                },
                MuiToolbar: {
                    root: {
                        backgroundColor: '#f00',
                    },
                },
                MuiTableCell: {
                    head: {
                        backgroundColor: 'purple',
                    },
                },
                MUIDataTableSelectCell: {
                    headerCell: {
                        backgroundColor: 'blue',
                    },
                },
                MuiTableFooter: {
                    root: {
                        '& .MuiToolbar-root': {
                            backgroundColor: 'white',
                        },
                    },
                },
            },
        });

    toggleDenseTable = event => {
        this.setState({
            denseTable: event.target.checked,
        });
    };

    toggleResponsive = event => {
        this.setState({
            vertical: !!event.target.checked,
        });
    };

    render() {
        const { coachesData } = this.props;
        const columns = [
            {
                name: "",
                options: {
                    filter: false,
                    sort: false,
                    viewColumns: false
                }
            },
            {
                name: "Name",
                options: {
                    filter: false,
                    setCellHeaderProps: value => ({ style: { textDecoration: 'underline', fontSize: '16px' } })
                }
            },
            {
                name: "Email",
                options: {
                    filter: true,
                    setCellHeaderProps: value => ({ style: { textDecoration: 'underline', fontSize: '16px' } })
                }
            },
            {
                name: "Phone",
                options: {
                    filter: false,
                    display: false,
                    setCellHeaderProps: value => ({ style: { textDecoration: 'underline', fontSize: '16px' } })
                }
            },
            {
                name: "Gender",
                options: {
                    filter: true,
                    setCellHeaderProps: value => ({ style: { textDecoration: 'underline', fontSize: '16px' } })
                }
            },
            {
                name: "DOB",
                options: {
                    filter: false,
                    display: false,
                    setCellHeaderProps: value => ({ style: { textDecoration: 'underline', fontSize: '16px' } })
                }
            },
            {
                name: "City",
                options: {
                    filter: false,
                    display: false,
                    setCellHeaderProps: value => ({ style: { textDecoration: 'underline', fontSize: '16px' } })
                }
            },
            {
                name: "Country",
                options: {
                    filter: false,
                    display: false,
                    setCellHeaderProps: value => ({ style: { textDecoration: 'underline', fontSize: '16px' } })
                }
            },
            {
                name: "Activation Date",
                options: {
                    filter: false,
                    setCellHeaderProps: value => ({ style: { textDecoration: 'underline', fontSize: '16px' } })
                }
            },
            {
                name: "Status",
                options: {
                    filter: true,
                    setCellHeaderProps: value => ({ style: { textDecoration: 'underline', fontSize: '16px' } }),
                    customBodyRender: (value, tableMeta, updateValue) => {
                        return (
                            <Badge className="jr-rounded-xs text-uppercase" color={value === "active" ? "info" : (value === "pending" ? "warning" : "danger")}>{value}</Badge>
                        );
                    }
                }
            }
        ];

        const options = {
            filterType: "dropdown",
            responsive: "scroll",
            selectableRows: "none",
        };

        return (
            <MUIDataTable
                title={"Coaches"}
                data={coachesData}
                columns={columns}
                options={options}
            />
        );
    }
}

export default AllCoachTable;